import { FooterPortal, NavbarPortal, SearchPortal } from "components";
import React, { useCallback, useEffect, useState } from "react";
import KnowledgeBase from "./KnowledgeBase";
import { FaRegHdd } from "react-icons/fa";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getData } from "actions";
import { API_URL_kbCategory } from "constants/api";
import { kbCategoryReducers } from "redux/kbCategorySlice";

const QuestionAnswer = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const [stateSearch, setStateSearch] = useState(
    location.state?.search ? location.state.search : ""
  );

  const state = location.state ? location.state : "";
  const [category, setCategory] = useState(state.category ?? "");
  const [namecategory, setNameCategory] = useState(state.category_name ?? "");
  let fetch = "";
  if (category === "" && stateSearch === "") {
    fetch = true;
  } else {
    fetch = category || stateSearch;
  }

  const { getKbCategoryResult } = useSelector((state) => ({
    getKbCategoryResult: state.kbCategory.getKbCategoryResult,
  }));

  const getKbCategory = useCallback(
    async (params) => {
      getData(
        API_URL_kbCategory,
        params,
        { dispatch, redux: kbCategoryReducers },
        "GET_KBCATEGORY"
      );
    },
    [dispatch]
  );

  const handleCategory = (item) => {
    setStateSearch("");
    setCategory(item.id);
    setNameCategory(item.name);
  };

  useEffect(() => {
    if (state.category) {
      setCategory(state.category);
    }
  }, [state]);

  useEffect(() => {
    const params = `?limit=${9999999}`;
    getKbCategory(params);
  }, []);

  useEffect(() => {
    setStateSearch(location.state?.search || "");
  }, [location.state]);

  return (
    <>
      <div className="flex flex-col min-h-screen overflow-y-auto text-gray-700">
        <main className="flex flex-grow">
          <div className="w-full">
            <NavbarPortal current={"Pertanyaan & Jawaban"} />

            <SearchPortal />

            <div className="mx-auto w-full max-w-[90rem] md:px-8 bg-transparent">
              <div className="relative mx-1 md:mx-0 bottom-6 bg-neutral-50 shadow-sm shadow-sky-800 rounded">
                <div className="mx-4 md:mx-10 py-2 md:py-4 grid grid-cols-12">
                  <div className="col-span-12 md:col-span-9">
                    <p className="text-black text-xl font-bold mb-2">
                      {stateSearch === ""
                        ? namecategory
                        : `Pencarian "${stateSearch}"`}
                    </p>
                    <hr className="mb-4 border border-gray-200 w-11/12" />

                    <div className="mr-5">
                      {fetch && (
                        <KnowledgeBase
                          category={category}
                          search={stateSearch}
                        />
                      )}
                    </div>
                  </div>
                  <div className="col-span-12 md:col-span-3">
                    <div className="flex flex-row justify-between items-center">
                      <h2 className="text-black text-lg font-bold ">
                        Kategori
                      </h2>
                      <FaRegHdd />
                    </div>
                    <hr className="mb-4 border border-gray-300" />
                    {getKbCategoryResult.results &&
                      getKbCategoryResult.results.map((items, index) => (
                        <div
                          key={index}
                          className={`mb-1 flex flex-row justify-between items-center border p-1 hover:bg-slate-100 cursor-pointer
                        ${category === items.id ? "bg-slate-200" : ""}
                        `}
                          onClick={() => {
                            handleCategory(items);
                          }}
                        >
                          <p className="">{items.name}</p>
                          <span className="bg-sky-600 text-white rounded px-1 h-6">
                            {items.count}
                          </span>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>

        <FooterPortal />
      </div>
    </>
  );
};

export default QuestionAnswer;
